import './styles.scss';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Head from 'Components/helpers/Head';
import SignupForm from 'Components/user/SignupForm';

export default class SignUp extends Component {
    static propTypes = {
        location: PropTypes.object.isRequired
    };

    render() {
        const { location } = this.props;

        return (
            <div className="container-signup">
                <Head
                    title={`Sign up`}
                    description={``}
                    canonical={`/signup`}
                    robots={`index, follow`}
                />
                <SignupForm location={location} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/user/SignUp/index.js